/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

/**
 * Client-side debug logging.
 * At the moment this simply logs to the browser console, but it's still useful to have dedicated
 * methods to allow collecting them in the future, or silencing them in production or in mocha
 * tests.
 */

export type LogMethod = (message: string, ...args: any[]) => void;

export const debug: LogMethod = console.debug.bind(console);
export const info: LogMethod = console.info.bind(console);
export const log: LogMethod = console.log.bind(console);
export const warn: LogMethod = console.warn.bind(console);
export const error: LogMethod = console.error.bind(console);
